import React, { StrictMode } from 'react'
import ReactDOMClient from 'react-dom/client'

import {
  applyBookingSegmentToRum,
  buildBookingSegmentContext,
  normalizeLocale,
} from 'shared-components'

import { APP_VERSION } from './constants'
import './datadog'
import DolphinBooking from './DolphinBooking'
import './i18n'
import './sentry'

require('@iframe-resizer/child')

const app = document.getElementById('app')
const root = ReactDOMClient.createRoot(app)

const urlParams = new URLSearchParams(window.location.search)
const locationId = urlParams.get('location_id')
const providerId = urlParams.get('provider_id')
const partnerId = urlParams.get('partner_id')
const lng = normalizeLocale(urlParams.get('lng'))
const source = urlParams.get('source')

// Extract attribution data from URL parameters
const attributionData = {
  utmSource: urlParams.get('utm_source'),
  utmMedium: urlParams.get('utm_medium'),
  utmCampaign: urlParams.get('utm_campaign'),
  utmTerm: urlParams.get('utm_term'),
  utmContent: urlParams.get('utm_content'),
  gclid: urlParams.get('gclid'),
  fbclid: urlParams.get('fbclid'),
  msclkid: urlParams.get('msclkid'),
  twclid: urlParams.get('twclid'),
  ttclid: urlParams.get('ttclid'),
  liFatId: urlParams.get('li_fat_id'),
}

// Only pass attributionData if at least one value is present and non-empty
const hasAttributionData = Object.values(attributionData).some(
  value => value !== null && value !== ''
)
const attributionDataProp = hasAttributionData ? attributionData : undefined

applyBookingSegmentToRum(
  buildBookingSegmentContext({
    locationId,
    partnerId,
    providerId,
  })
)

console.debug('dolphin-booking version:', APP_VERSION)

root.render(
  <StrictMode>
    <DolphinBooking
      locationId={locationId}
      providerId={providerId}
      partnerId={partnerId}
      source={source}
      attributionData={attributionDataProp}
      lng={lng}
    />
  </StrictMode>
)
